/* eslint-disable */
import { auth } from "@/plugins/auth/firebase.js";
import Cookie from "js-cookie";
import JWTDecode from "jwt-decode";
import axios from "axios";
import * as vars from "@/vars.json";

const httpAxios = axios.create({
  params: {}
});

export const categories = {
  namespaced: true,
  state: {
    category_list: null,
    currentItem: {},
    isLoading: false
  },
  mutations: {
    SET_CATEGORY_LIST(state, payload) {
      state.category_list = payload;
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload;
    },
    SET_CURRENT_ITEM(state, payload) {
      state.currentItem = payload;
    }
  },

  actions: {
    loadItems({ commit, state, rootState, dispatch }, type) {
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        // console.log(userId)
        let path;
        let loadCommit;

        switch (type) {
          case "categories":
            path = `users/${userId}/categories`;
            loadCommit = "SET_CATEGORY_LIST";
            break;
        }

        firebase
          .database()
          .ref(path)
          .orderByChild("name")
          .on(
            "value",
            function(snapshot) {
              const items = [];
              snapshot.forEach(function(child) {
                items.push({
                  ...child.val(),
                  id: child.key
                });
              });

              items.sort(function(a, b) {
                const nameA = a.name.toUpperCase(); // ignore upper and lowercase
                const nameB = b.name.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                // names must be equal
                return 0;
              });

              commit(loadCommit, items);
              commit("SET_LOADING", false);
              resolve();
            },
            function(error) {
              console.error(error);
              dispatch("users/showErrorSessionExpired", null, { root: true });
              commit("SET_LOADING", false);
              reject();
            }
          );
      });
    },
    setCurrentItem({ commit, state, rootState }, payload) {
      // commit('SET_LOADING', true);
      // console.log(payload)
      const vm = this;
      let userId = "";
      if (rootState.users.user.adminUid) {
        userId = rootState.users.user.adminUid;
      } else {
        userId = rootState.users.user.uid;
      }
      if (payload.type === "default") {
        // console.log(payload)
        commit("SET_CURRENT_ITEM", payload);
      } else {
        return new Promise((resolve, reject) => {
          const path = `users/${userId}/categories`;
          const setCommit = "SET_CURRENT_ITEM";
          let id;

          const currentItem = state.category_list.find(
            item => item.id === payload.id
          );
          if (currentItem) {
            // console.log(currentItem)
            commit(setCommit, currentItem);
            resolve();
          } else {
            id = payload.id;
            // console.log(currentItem)
            const dbRef = firebase.database().ref();
            let item;

            dbRef.child(path + "/" + id).on(
              "value",
              function(data) {
                // console.log(data.val(), id)
                item = {
                  ...data.val(),
                  id: data.key
                };
                commit(setCommit, item);
                // commit('setLoading', false);
                resolve();
              },
              function(error) {
                // console.log(error)
                // commit('setLoading', false);
                reject();
              }
            );
          }
        });
      }
    },
    deleteItem({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        const id = payload;
        commit("SET_LOADING", true);
        const promises = [];
        // console.log(`categories/pictures/${id}`)
        promises.push(
          firebase
            .database()
            .ref()
            .child(`users/${userId}/categories/${id}`)
            .remove()
        );
        promises.push(
          firebase
            .storage()
            .ref(`users/${userId}/categories/pictures/${id}`)
            .child("imageInput1")
            .delete()
        );
        Promise.all(promises).then(
          function() {
            // commit('setWriting', false);
            resolve();
          },
          function(error) {
            commit("SET_LOADING", false);
            // console.log(error)
            reject();
          }
        );
      });
    },
    categoryLoading({ commit }) {
      commit("SET_LOADING", true);
    },
    async createItem({ commit, state, rootState }, payload) {
      commit("SET_LOADING", true);
      let userId = "";
      if (rootState.users.user.adminUid) {
        userId = rootState.users.user.adminUid;
      } else {
        userId = rootState.users.user.uid;
      }
      // console.log(state.user, userId)
      const key = payload.id
        ? payload.id
        : firebase
            .database()
            .ref()
            .child(`users/${userId}/categories`)
            .push().key;
      const itemData = {
        ...payload,
        id: key,
        created: firebase.database.ServerValue.TIMESTAMP
      };
      const updates = {};
      updates[`users/${userId}/categories/${key}`] = itemData;
      await firebase
        .database()
        .ref()
        .update(updates)
        .then(function() {
          // created!
          commit("SET_LOADING", false);
        });
    },
    async updateItem({ commit, state, rootState }, payload) {
      commit("SET_LOADING", true);
      const vm = this;

      let userId = "";
      if (rootState.users.user.adminUid) {
        userId = rootState.users.user.adminUid;
      } else {
        userId = rootState.users.user.uid;
      }
      const itemData = payload;
      await firebase
        .database()
        .ref(`users/${userId}/categories/${itemData.id}`)
        .update(itemData)
        .then(function() {
          // updated!
          commit("SET_LOADING", false);
        })
        .catch(function(err) {
          commit("SET_LOADING", false);
          throw err;
        });
    },
    getSubcategories({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        httpAxios
          .post(vars.url + "/getSubcategories", payload)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    createUpdateSubcategory({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        httpAxios
          .post(vars.url + "/createUpdateSubcategory", payload)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteSubcategory({ commit, state, rootState }, payload) {
      commit("SET_LOADING", true);
      const userId = rootState.users.user.adminUid || rootState.users.user.uid;
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref(`users/${userId}/categories/${payload.id}`)
          .remove()
          .then(() => {
            // If successful, you can commit mutations or do any other necessary actions
            commit("SET_LOADING", false);
            resolve("Subcategory deleted successfully");
          })
          .catch(error => {
            // Handle errors here
            commit("SET_LOADING", false);
            reject(error);
          });
      });
    }
  },
  getters: {
    getItems(state) {
      return state.category_list;
    },
    getCurrentItem(state) {
      return state.currentItem;
    },
    isLoading(state) {
      return state.isLoading;
    }
  }
};
